import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IUserFurtherEducationEditItem, UserFurtherEducationEditItem } from "./userFurtherEducationEditItem";
import { IRecordListItemUserQualification, RecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";

export interface IUserFurtherEducationEdit {
    item: IUserFurtherEducationEditItem;
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];
    qualifications: IRecordListItemUserQualification[];
    attachments: IFileAttachment[];
}

export class UserFurtherEducationEdit implements IUserFurtherEducationEdit {
    item: UserFurtherEducationEditItem;
    furtherEducationGroups: RecordFurtherEducationGroupNode[];
    qualifications: RecordListItemUserQualification[];
    attachments: FileAttachment[];

    constructor();
    constructor(obj: IUserFurtherEducationEdit);
    constructor(obj?: any) {
        this.item = null;
        if (obj && obj.item) {
            this.item = new UserFurtherEducationEditItem(obj.item);
        }
        this.furtherEducationGroups = Base.getTypedArray(obj ? obj.furtherEducationGroups : null, RecordFurtherEducationGroupNode);
        this.qualifications = Base.getTypedArray(obj ? obj.qualifications : null, RecordListItemUserQualification);
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
    }
}